import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './containers/App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { publicRoutes, privateRoutes } from './keystoneMyOpenRoutes';
import registerServiceWorker from './registerServiceWorker';
import store from './store/keystoneMyOpenStore';
import KeystoneMenuAppBar from './components/KeystoneMenuAppBar';
import {
    getSynchroActiveUser,
    synchronization,
    initSynchronisations,
    getDefaultSyncState,
} from "./redux/synchro/keystoneSynchroActions";

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <App appBar={<KeystoneMenuAppBar getSynchroActiveUser={getSynchroActiveUser} synchronization={synchronization} />}
                initSynchronisations={initSynchronisations} getDefaultSyncState={getDefaultSyncState} publicRoutes={publicRoutes} privateRoutes={privateRoutes}/>
        </BrowserRouter>
    </Provider>
, document.getElementById('root'));

registerServiceWorker();
(function() {
    if ("Notification" in window) {
        var permission = Notification.permission;

        if (permission === "denied" || permission === "granted") {
            return;
        }

        Notification.requestPermission();

    }
})();
